module.exports = __webpack_public_path__ + "7cb9b2198393508c61b145cef1d30c3d.jpg";